import { resolvePath } from '@/utils/path'

export default {
  methods: {
    resolvePathWithBasePath(basePath, routePath) {
      return resolvePath(basePath, routePath)
    },
  },
}
